import { render } from "./AdminTopbar.vue?vue&type=template&id=a840b2a8&scoped=true"
import script from "./AdminTopbar.vue?vue&type=script&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&lang=js"

import "./AdminTopbar.vue?vue&type=style&index=0&id=a840b2a8&scoped=true&lang=css"
import "./AdminTopbar.vue?vue&type=style&index=1&id=a840b2a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a840b2a8"]])

export default __exports__